
var hashHandlerInit;

(function ($) {

	hashHandlerInit = function () {

		const url = window.location.href;
		const target = window.location.hash.replace('#', '');
		window.location.hash = "";

		if (target) $(document).ready(_ => {

			const $target = $('#' + target + ', [data-id="' + target + '"]').filter(':visible');

			if ($target.length) {
				history.replaceState({}, '', url);
				$('html, body').stop().animate({ scrollTop: $target.offset().top - 70 }, 700);
			}

		});

	}

})(jQuery);

export default hashHandlerInit;